import { createApi } from "@dreambigger/shared/src/api/api";
import * as Sentry from "@sentry/nextjs";
import axios from "axios";
import { delay } from "@dreambigger/shared/src/utils";

const api = createApi(
  process.env.NEXT_PUBLIC_ACQUIRE_API_URL || "",
  process.env.NEXT_PUBLIC_COTRIBUTE_CLIENT_ID || ""
);

export const captureApiError = (e: any) => {
  Sentry.captureException(e);
  console.error(e);
  // capture errror details
  if (!axios.isAxiosError(e)) {
    Sentry.captureMessage(`Api Error: ${e}`);
    return;
  }
  if (e.response) {
    Sentry.captureMessage(
      `Api Error Response: ${JSON.stringify(
        e.response
      )} || Api Request: ${JSON.stringify(e.request)}`
    );
    return;
  }
  Sentry.captureMessage(`Api Error Request: ${JSON.stringify(e.request)}`);
};

export const callApiWithRetry = async (
  callApi: () => any,
  handleError = captureApiError,
  retries = 5,
  wait = 500
) => {
  let retriesLeft = retries;
  let currentWait = wait;
  while (retriesLeft > 0) {
    try {
      return await callApi();
    } catch (e) {
      handleError(e);
      if (retriesLeft === 1 || !axios.isAxiosError(e) || e.response) {
        throw e;
      }
    }
    await delay(currentWait);
    currentWait = currentWait * 2;
    retriesLeft--;
  }
};

export default api;
